import { Switch } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';

type Props = {
  hint?: string;
  onChange: () => void;
  checked: boolean;
};

export const MembershipRequired = observer(({ hint, onChange, checked }: Props) => {
  return (
    <div className='admin-edit-section'>
      <h2>Restrictions</h2>
      <Switch label='Premium required' hint={hint} onChange={() => onChange()} checked={checked} />
    </div>
  );
});

export default MembershipRequired;
